module.exports = __webpack_public_path__ + "static/media/foodOrdersIcon.4f325fe0.svg";